// Documento: Como funciona la bandeja de entrada
// Categoría: General
// Última actualización: 2024-12-28

const document = {
  "id": "como-funciona-bandeja-entrada",
  "title": "Como funciona la bandeja de entrada",
  "category": "General",
  "description": "Runamatic ofrece una bandeja de entrada unificada y multi agente. Descubre todas las funcionalidades y herramientas disponibles para gestionar eficientemente las conversaciones de todos tus canales conectados.",
  "explanations": [
    {
      "title": "Bandeja de entrada unificada",
      "content": "Runamatic ofrece una bandeja de entrada unificada y multi agente. Se podrán ver los chats de todos los canales conectados a su cuenta, tanto texto, imágenes, archivos, audios, transcripciones de audios, videos y llamadas telefónicas. La bandeja de entrada ofrece múltiples herramientas para agilizar las operaciones de su negocio en el día a día.",
      "images": [
        "https://drive.google.com/thumbnail?id=1ssfL8B60ECyQ8-gwXNH-ZTG-T-6IgTcs&sz=w1000"
      ]
    },
    {
      "title": "Filtro de asignación",
      "content": "El filtro de asignación permite filtrar rápidamente chats asignados a humanos o bots. Esta funcionalidad es especialmente útil cuando tienes un equipo de atención al cliente y necesitas ver rápidamente qué conversaciones están siendo manejadas por asesores humanos y cuáles por la automatización.",
      "images": [
        "https://drive.google.com/thumbnail?id=1UI-02pl0dvzbKU_RhIp75lZfsnGPgGCg&sz=w1000"
      ]
    },
    {
      "title": "Filtro general",
      "content": "El filtro general permite filtrar por canal, conversaciones asignadas o sin asignar, chats en seguimiento o sin leer y configurar filtros personalizados. Esta herramienta te permite organizar y encontrar rápidamente las conversaciones específicas que necesitas atender según diferentes criterios.",
      "images": [
        "https://drive.google.com/thumbnail?id=1CC7H69P2vPUx0TlmPCLnw5VvV7DEBlla&sz=w1000"
      ]
    },
    {
      "title": "Asignación manual",
      "content": "La asignación manual permite asignar el chat a los usuarios de su cuenta. Esta funcionalidad es fundamental para la gestión de equipos, ya que permite distribuir las conversaciones entre diferentes miembros del equipo según su especialidad, disponibilidad o carga de trabajo.",
      "images": [
        "https://drive.google.com/thumbnail?id=1syRR0ExIfZ5qLqwVYNfKhnouJksf0Qqe&sz=w1000"
      ]
    },
    {
      "title": "Acciones de contacto",
      "content": "Las acciones de contacto permiten derivar la conversación al bot, marcarla para seguimiento, archivar, bloquear o eliminar contacto. Estas opciones te dan control total sobre la gestión de cada contacto, permitiendo organizar tu bandeja de entrada de manera eficiente.",
      "images": [
        "https://drive.google.com/thumbnail?id=1O16vH7T6OpFOUcaJzx3f9a0CIqP6MnI3&sz=w1000"
      ]
    },
    {
      "title": "Acciones de chat",
      "content": "Desde las acciones de chat se podrán realizar distintas acciones dependiendo el canal que se esté usando. Por ejemplo, WhatsApp ofrecerá el envío de plantillas. Pero las acciones generales disponibles son envío de flujos, enviar productos si el catálogo está activo, crear citas si tiene al menos un calendario activo, emojis y respuestas rápidas.",
      "images": [
        "https://drive.google.com/thumbnail?id=1OqW0CKy-CxKX-enDN9UiV9Y2J08kjn9u&sz=w1000"
      ]
    },
    {
      "title": "Información del contacto",
      "content": "Aquí se mostrará toda la información del contacto. Los distintos canales ofrecen información distinta, pero se puede configurar la automatización para que consulte datos y los cargue en esta sección. Esta sección es totalmente adaptable, permitiendo personalizar qué información se muestra según las necesidades específicas de tu negocio.",
      "images": [
        "https://drive.google.com/thumbnail?id=1y9uj74GDWT88Bil_yoxh8x8lAsPlwnS3&sz=w1000"
      ]
    },
    {
      "title": "Pipelines",
      "content": "Esta sección estará activa si tiene al menos un CRM o Pipeline activo. Permite ver las oportunidades del contacto, se puede acceder a la oportunidad dándole click a este elemento. También se puede cambiar de etapa a la oportunidad desde la bandeja de entrada, facilitando la gestión de ventas sin necesidad de cambiar de pantalla.",
      "images": [
        "https://drive.google.com/thumbnail?id=15eU_zuPsfAeSn35XvlsRcDgiQfIattiF&sz=w1000"
      ]
    },
    {
      "title": "Notas, medios y archivos, etiquetas y secuencias suscritas",
      "content": "Las notas permiten a los usuarios de la cuenta poder mantener una conversación sobre cada contacto, la conversación es interna. Los medios y archivos permiten ver todos los archivos enviados y recibidos con el contacto. Las secuencias se mostrarán solo si tiene secuencias activas, esta sección muestra esa información. La sección de etiquetas mostrará todas las etiquetas aplicadas al contacto.",
      "images": [
        "https://drive.google.com/thumbnail?id=1KnEEf1x2v9IVWGRN1Ec3h6PwbqaHbqdU&sz=w1000"
      ]
    },
    {
      "title": "Acciones ejecutadas",
      "content": "Al activar esta opción, se mostrará en el área de chat las acciones realizadas por la automatización o usuarios humanos. Esta funcionalidad es muy útil para hacer seguimiento de las interacciones y entender qué acciones se han ejecutado en cada conversación.",
      "images": [
        "https://drive.google.com/thumbnail?id=1NHlzJYngkyZTkLukSsflV-vi4kESuZmV&sz=w1000"
      ]
    },
    {
      "title": "Biblioteca de medios",
      "content": "Esta sección permite guardar los archivos más usados por el negocio y poder enviarlos de manera sencilla. Es una funcionalidad muy práctica para equipos que necesitan enviar frecuentemente los mismos documentos, imágenes o archivos multimedia a sus clientes.",
      "images": [
        "https://drive.google.com/thumbnail?id=1iZhfSXotVthVrTVZP8-xPYdTkgojNXKi&sz=w1000",
        "https://drive.google.com/thumbnail?id=1WvnRRxIHwbx9vwHol4qIz3NMvzVGXXiz&sz=w1000"
      ]
    }
  ],
  "tags": [
    "bandeja-entrada",
    "gestión",
    "filtros",
    "asignación",
    "contactos",
    "chat",
    "multicanal",
    "herramientas",
    "organización"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
